import { render, staticRenderFns } from "./policy-log.vue?vue&type=template&id=5a2d0844&scoped=true&"
import script from "./policy-log.vue?vue&type=script&lang=js&"
export * from "./policy-log.vue?vue&type=script&lang=js&"
import style0 from "./policy-log.vue?vue&type=style&index=0&id=5a2d0844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d0844",
  null
  
)

export default component.exports